
(function () {
  function formatMoney(cents) {
    const amount = Math.round(cents / 100);
    return amount.toLocaleString('uk-UA') + ' ₴';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function buildCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const available = !!product.available;
    const price = product.price;
    const compareAt = product.compare_at_price;
    const isSale = compareAt && compareAt > price;
    const strings = window.wishlistStrings || {};
    const url = '/products/' + product.handle;
    const title = escapeHtml(product.title);

    const priceHtml = isSale
      ? '<span class="gm-product-card__price-compare">' +
        formatMoney(compareAt) +
        '</span><span class="gm-product-card__price-current">' +
        formatMoney(price) +
        '</span>'
      : formatMoney(price);

    const card = document.createElement('div');
    card.className = 'gm-product-card' + (available ? '' : ' gm-product-card--soldout');
    card.innerHTML =
      '<div class="gm-product-card__media">' +
      '<button type="button" class="gm-wishlist-toggle gm-wishlist-toggle--active gm-product-card__wishlist" ' +
      'data-gm-wishlist-toggle="' +
      escapeHtml(product.handle) +
      '" aria-pressed="true" aria-label="' +
      escapeHtml(strings.remove) +
      '"><svg class="gm-icon gm-icon--heart gm-wishlist-toggle__icon" width="20" height="20" aria-hidden="true" focusable="false">' +
      '<use href="#gm-heart"></use></svg></button>' +
      '<a href="' +
      url +
      '" class="gm-product-card__media-link">' +
      (image ? '<img src="' + image + '" alt="' + title + '" loading="lazy" width="600" height="750">' : '') +
      '</a>' +
      '</div>' +
      '<a href="' +
      url +
      '" class="gm-product-card__title link link--text gm-body-m">' +
      title +
      '</a>' +
      '<p class="gm-product-card__price gm-price-m' +
      (isSale ? ' gm-product-card__price--sale' : '') +
      '">' +
      priceHtml +
      '</p>';
    return card;
  }

  function render() {
    const grid = document.querySelector('[data-gm-wishlist-grid]');
    const empty = document.querySelector('[data-gm-wishlist-empty]');
    if (!grid || !empty || !window.gmWishlist) return;

    const handles = window.gmWishlist.readWishlist();
    if (handles.length === 0) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      const found = products.filter(Boolean);
      grid.innerHTML = '';
      if (found.length === 0) {
        grid.hidden = true;
        empty.hidden = false;
        return;
      }
      found.forEach(function (product) {
        grid.appendChild(buildCard(product));
      });
      grid.hidden = false;
      empty.hidden = true;
    });
  }

  document.addEventListener('gm:wishlist:change', render);
  render();
})();
